import { BaseService } from "./base.service";
export class CriterionCategoriesService extends BaseService {
  constructor() {
    super("criterion-categories");
  }
}
